import DailyManual from "@/services/DailyManual.service";

const state = {
    getData : [],
    getTechData: [],
    gettingDataByID: []
}

const mutations = {
    setData(state, payload){
        state.getData = payload;
    },
    clearData(state){
        state.getData = [];
    },
    set_TechData(state, payload){
        state.getTechData = payload;
    },
    clear_TechData(state){
        state.getTechData = [];
    },
    clear_insert(){
        console.log('insert');
    },
    clear_delete(){
        console.log('delete')
    },
    clear_dataID(state){
        state.gettingDataByID = [];
    },
    set_dataID(state, payload){
        state.gettingDataByID = payload;
    }
}
const actions = {
    async getAllDataFromApi({commit}, payload) {
        await commit("clearData");
        const all = await DailyManual.getAllManualData(payload);
        await commit("setData", all);
        return all.data;
    },
    async getAllTechnicalDataFromApi({commit}, payload) {
        await commit("clear_TechData");
        const all = await DailyManual.getTechnicalData(payload);
        await commit("set_TechData", all);
        return all.data;
    },
    async insertManualData({commit}, payload) {
        console.log(payload);
        await commit("clear_insert");
        const response = await DailyManual.insertManual(payload)
            .then((response) => {
                console.log(response);
            })
        return response;
    },
    async deleteByManualID({commit}, payload){
        console.log(payload);
        await commit("clear_delete");
        const response = await DailyManual.deleteID(payload)
            .then((response) => {
                console.log(response);
            })
        return response;
    },
    async getManualByID({commit}, payload){
        await commit('clear_dataID');
        const response = await DailyManual.getDataByID(payload);
        await commit("set_dataID", response);
        return response.data;
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
